<template>
  <div id="change-password">
    <h1 class="center-text">Finish Creating Your Account</h1>
    <form @submit.prevent="createUserPassword">
      <div class="form-300 center-element">
        <div v-if="apiError" class="error">
          Error: {{ apiErrorMessage }}<br />
        </div>
        <div v-if="isError" class="error">Error with form<br /></div>
        <label>
          Set Your Password<br />
          <input
            v-model.trim="payload.password"
            type="password"
            placeholder="create password"
            onfocus="this.placeholder = ''"
            onblur="this.placeholder = 'create password'"
            required
          /><br />
        </label>
        <div v-if="isPasswordError" class="error">
          {{ errorPasswordMessage }}
        </div>
        <button class="button button-300" type="submit">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/index";
import router from "@/router";
const apiServiceUser = new api.APIServiceUser();

// @ is an alias to /src
export default {
  data() {
    return {
      payload: {
        token: this.$route.params.token,
        new_password: "",
        new_user: true
      },
      isError: false,
      isPasswordError: false,
      errorPasswordMessage: "",
      apiError: false,
      apiErrorMessage: ""
    };
  },
  created() {
    this.isPasswordError = false;
    this.errorPasswordMessage = "";
    this.isError = false;
  },
  methods: {
    createUserPassword: function() {
      this.isPasswordError = false;
      this.errorPasswordMessage = "";
      this.isError = false;
      if (this.payload.password.length < 8) {
        this.isError = true;
        this.isPasswordError = true;
        this.errorPasswordMessage =
          "Password length must be 8 characters or longer";
      }
      if (!this.isPasswordError) {
        apiServiceUser
          .createUserPassword(this.payload)
          .then(data => {
            router.push("/console/dashboard/users");
          })
          .catch(error => {
            this.apiError = true;
            this.apiErrorMessage = error;
          });
      }
    }
  }
};
</script>
<style>
#change-password {
  text-align: left;
  margin-left: 20px;
}
#edit-password div {
  font-size: 1.2em;
  padding: 15px;
}
</style>
